
import Vue from "vue";
// eslint-disable-next-line
const datePicker: any = Vue.extend({
  props: {
    value: {
      type: String,
      default: new Date().toISOString().substr(0, 10),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    month: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    picker: {
      get(): string {
        return this.value;
      },
      set(val: string) {
        this.menu = false;
        this.$emit("input", val);
      },
    },
  },
});

export default datePicker;
